
import { useMemo } from "react";
import { Message as UIMessage } from "@/types/message";

interface UseConversationThreadProps {
  messages: UIMessage[];
  isRegenerating: boolean;
  isAIGenerating: boolean;
  isPasting: boolean;
  isProcessingAI: boolean;
  onPasteSellerResponse: (content: string) => void;
}

export const useConversationThread = ({
  messages,
  isRegenerating,
  isAIGenerating,
  isPasting,
  isProcessingAI,
  onPasteSellerResponse,
}: UseConversationThreadProps) => {
  // Find latest AI message for regeneration
  const latestAIMessage = useMemo(() => {
    // Get all AI messages, sorted by timestamp descending
    return [...messages]
      .filter(msg => msg.type === 'ai')
      .sort((a, b) => b.timestamp.getTime() - a.timestamp.getTime())[0];
  }, [messages]);
  
  const hasAIMessages = messages.some(msg => msg.type === "ai");

  const handleGenerateInitialResponse = async () => {
    await onPasteSellerResponse("");
  };

  // Calculate whether any loading state is active
  const isAnyLoading = isRegenerating || isAIGenerating || isPasting || isProcessingAI;

  return {
    latestAIMessage,
    hasAIMessages,
    isAnyLoading,
    handleGenerateInitialResponse,
  };
};
